(() => {
  "use strict";

  class UsageSteps {
    constructor(section) {
      this.section = section;

      if (!this.section || this.section.dataset.initialized === "true") {
        return;
      }

      this.section.dataset.initialized = "true";

      this.tabs = Array.from(
        this.section.querySelectorAll("[data-usage-tab]")
      );

      this.slides = Array.from(
        this.section.querySelectorAll("[data-usage-slide]")
      );

      this.track = this.section.querySelector("[data-usage-track]");
      this.previousButton = this.section.querySelector(
        "[data-usage-previous]"
      );
      this.nextButton = this.section.querySelector("[data-usage-next]");

      this.currentIndex = 0;
      this.totalSlides = this.slides.length;

      if (!this.track || this.tabs.length === 0 || this.slides.length === 0) {
        return;
      }

      this.setStepCount();
      this.bindEvents();
      this.update(0, false);
    }

    setStepCount() {
      this.section.style.setProperty(
        "--usage-step-count",
        String(this.tabs.length)
      );
    }

    normalizeIndex(index) {
      if (index < 0) {
        return this.totalSlides - 1;
      }

      if (index >= this.totalSlides) {
        return 0;
      }

      return index;
    }

    update(index, moveFocus = false) {
      this.currentIndex = this.normalizeIndex(index);

      this.track.style.transform = `translate3d(-${
        this.currentIndex * 100
      }%, 0, 0)`;

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === this.currentIndex;

        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.setAttribute("tabindex", isActive ? "0" : "-1");

        if (isActive && moveFocus) {
          tab.focus();
        }
      });

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.currentIndex;

        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
    }

    bindEvents() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          this.update(index);
        });

        tab.addEventListener("keydown", (event) => {
          switch (event.key) {
            case "ArrowRight":
              event.preventDefault();
              this.update(index + 1, true);
              break;

            case "ArrowLeft":
              event.preventDefault();
              this.update(index - 1, true);
              break;

            case "Home":
              event.preventDefault();
              this.update(0, true);
              break;

            case "End":
              event.preventDefault();
              this.update(this.totalSlides - 1, true);
              break;

            default:
              break;
          }
        });
      });

      if (this.previousButton) {
        this.previousButton.addEventListener("click", () => {
          this.update(this.currentIndex - 1);
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener("click", () => {
          this.update(this.currentIndex + 1);
        });
      }

      this.section.addEventListener("touchstart", (event) => {
        this.touchStartX = event.changedTouches[0].clientX;
      }, {
        passive: true
      });

      this.section.addEventListener("touchend", (event) => {
        if (window.innerWidth <= 749 || typeof this.touchStartX !== "number") {
          return;
        }

        const touchEndX = event.changedTouches[0].clientX;
        const difference = this.touchStartX - touchEndX;
        const swipeThreshold = 50;

        if (Math.abs(difference) < swipeThreshold) {
          return;
        }

        if (difference > 0) {
          this.update(this.currentIndex + 1);
        } else {
          this.update(this.currentIndex - 1);
        }

        this.touchStartX = null;
      }, {
        passive: true
      });
    }

    selectThemeEditorBlock(blockId) {
      if (!blockId) {
        return;
      }

      const selectedElement = this.section.querySelector(
        `[data-shopify-editor-block*="${blockId}"]`
      );

      if (!selectedElement) {
        return;
      }

      const tab = selectedElement.matches("[data-usage-tab]")
        ? selectedElement
        : selectedElement.closest("[data-usage-tab]");

      if (!tab) {
        return;
      }

      const index = Number(tab.dataset.index);

      if (!Number.isNaN(index)) {
        this.update(index);
      }
    }
  }

  const initializeSections = (container = document) => {
    const sections = container.querySelectorAll("[data-usage-steps]");

    sections.forEach((section) => {
      section.usageStepsInstance = new UsageSteps(section);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeSections();
    });
  } else {
    initializeSections();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeSections(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const section = event.target.closest("[data-usage-steps]");

    if (!section) {
      return;
    }

    if (!section.usageStepsInstance) {
      section.usageStepsInstance = new UsageSteps(section);
    }

    section.usageStepsInstance.selectThemeEditorBlock(
      event.detail && event.detail.blockId
    );
  });
})();